import PropTypes from 'prop-types';

import { legacyTheme, styled } from '@prose-ui/legacy';

import TrayCard from 'Components/TrayCard';

const TexturesWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-top: 32px;
  column-gap: 50px;
  ${legacyTheme.breakpoints.up('md')} {
    margin-top: 50px;
  }
`;

const TextureWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-basis: ${({ fullRow }) => fullRow && '100%'};
`;

const TexturesCards = ({
  textures: { pref_texture_slug, ranked_skeletons },
  onClickOption,
  selectedTexture,
}) => {
  return (
    <TexturesWrapper>
      {ranked_skeletons?.map(
        (texture, index) =>
          texture.is_visible && (
            <TextureWrapper key={texture.skeleton_slug} fullRow={index === 0}>
              <TrayCard
                dataTestId="skincare-texture-card"
                description={texture.description}
                hasImageBorder
                imageUrl={texture.url}
                isCurrentChoice={pref_texture_slug === texture.skeleton_slug}
                isNotRecommended={texture.is_not_recommended}
                isRecommended={texture.is_recommended}
                label={texture.name}
                onClick={() => onClickOption(texture.skeleton_slug)}
                recommendedReason={texture.recommendation}
                selected={selectedTexture === texture.skeleton_slug}
                width={100}
              />
            </TextureWrapper>
          )
      )}
    </TexturesWrapper>
  );
};

TexturesCards.propTypes = {
  onClickOption: PropTypes.func.isRequired,
  textures: PropTypes.shape({
    pref_texture_slug: PropTypes.string,
    ranked_skeletons: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  selectedTexture: PropTypes.string,
};

TexturesCards.defaultProps = {
  selectedTexture: null,
};

export default TexturesCards;
